import React from "react";
import "./Footer2.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

const Footer2: React.FC = () => {

  return (
    <footer className="footersub text-white">
      <div >
        <hr className="footer-divider " />
        <div className="text-center">
          <p className="copyright-text mb-0">
            Copyright © 2025 Xyloite Technologies | All Rights Reserved
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer2;
